import { render } from "./AudienceThemePicker.vue?vue&type=template&id=89f5db10"
import script from "./AudienceThemePicker.vue?vue&type=script&setup=true&lang=js"
export * from "./AudienceThemePicker.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/audience/AudienceThemePicker.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "89f5db10"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('89f5db10', __exports__)) {
    api.reload('89f5db10', __exports__)
  }
  
  module.hot.accept("./AudienceThemePicker.vue?vue&type=template&id=89f5db10", () => {
    api.rerender('89f5db10', render)
  })

}


export default __exports__